module.exports = __webpack_public_path__ + "img/gf.7656566f.svg";